import { getCoreRowModel, Row, useReactTable } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import React from 'react';

import { JsonDataViewer, ServerTableLayout } from 'shared/ui';

import { MongoSessionDTO } from 'entities/session';

import { useColumns } from '../hooks/use-columns';
import {
  useFiltersState,
  usePaginationState,
  useSortingState,
} from 'shared/ui/table/hooks';

type Props = {
  tableData: MongoSessionDTO[];
  loading: boolean;
  count: number | undefined;
  tablePageSize: number;
  tableHeadRef: (element: HTMLElement | SVGElement | null) => void;
};

export function ClientBankCardSessionsTableInstance({
  tableData,
  loading,
  count,
  tableHeadRef,
  tablePageSize,
}: Props) {
  const [sessionToShowInJSON, setSessionToShowInJSON] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();

  const columns = useColumns();

  const ordering = searchParams.get('ordering');
  const type = searchParams.get('type');
  // const phone = searchParams.get('phone'); // Не используется
  const cpName = searchParams.get('cpName');
  const page = searchParams.get('page');
  const limit = searchParams.get('limit');
  const search = searchParams.get('search');
  const searchText = searchParams.get('searchText');
  const dateFrom = searchParams.get('dateFrom');
  const dateTo = searchParams.get('dateTo');
  // const groupId = searchParams.get('groupId');

  const sorting = useSortingState();
  const pagination = usePaginationState();
  const filters = useFiltersState();

  const data = useMemo(() => tableData, [tableData]);

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
      columnFilters: filters,
      pagination,
    },
    getCoreRowModel: getCoreRowModel(),
    manualPagination: true,
    pageCount: count
      ? Math.ceil(count / (limit ? Number(limit) : tablePageSize))
      : undefined,
  });

  const handleRowDoubleClick = (row: Row<MongoSessionDTO>) => {
    setSessionToShowInJSON(row.original._id);
  };

  if (sessionToShowInJSON) {
    const sessionJSON = tableData.find(
      (session) => session._id === sessionToShowInJSON
    ) as MongoSessionDTO;

    return (
      <JsonDataViewer
        data={sessionJSON}
        onClick={() => setSessionToShowInJSON('')}
      />
    );
  }

  return (
    <ServerTableLayout
      table={table}
      loading={loading}
      pageSize={tablePageSize}
      tableHeadRef={tableHeadRef}
      handleRowDoubleClick={handleRowDoubleClick}
      rowsCount={count}
    />
  );
}

export default React.memo(ClientBankCardSessionsTableInstance);
